export default{
    trenutniKorisnik: null,
    trazi: '',
    traziPocetna: '',
    traziZ: "",
};